import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 按钮。
 *
 * 五个变体对应五种语义：
 *   primary —— 页面的主操作，一个视图里最多一个
 *   ghost   —— 次要操作（筛选器、取消、编辑）
 *   subtle  —— 表格行内的轻量操作，视觉上不该跟主操作抢
 *   danger  —— 不可逆操作（删除），出现即提示风险
 *   warn    —— 影响面大但可逆（下架、暂停），比 ghost 重、比 danger 轻。
 *              有边框、琥珀色：一排三个按钮时不必读字就能分辨"哪个会动到线上"
 *
 * `size="sm"` 只影响行内密集场景；默认 `md` 与改动前一致，
 * 所以既有调用点不用动。
 */
export function Button({ children, onClick, variant = 'primary', size = 'md', disabled, type = 'button', title, 'aria-label': ariaLabel, className, }) {
    const classes = ['ui-btn', `ui-btn--${variant}`, `ui-btn--${size}`];
    if (className)
        classes.push(className);
    return (_jsx("button", { className: classes.join(' '), onClick: onClick, disabled: disabled, type: type, title: title, "aria-label": ariaLabel, children: children }));
}
export function Card({ title, description, children, actions, footer, flush, inline, className }) {
    const classes = ['ui-card'];
    if (flush)
        classes.push('ui-card--flush');
    if (className)
        classes.push(className);
    return (_jsxs("section", { className: classes.join(' '), children: [(title || actions) && (_jsxs("header", { className: `ui-card__head${inline ? ' is-inline' : ''}`, children: [_jsxs("div", { children: [title ? _jsx("h2", { className: "ui-card__title", children: title }) : null, description ? _jsx("p", { className: "ui-card__desc", children: description }) : null] }), actions] })), children, footer ? _jsx("footer", { className: "ui-card__foot", children: footer }) : null] }));
}
export function Badge({ children, tone = 'neutral' }) {
    return _jsx("span", { className: `ui-badge ui-badge--${tone}`, children: children });
}
/** 金额统一按"分"传入，展示层只做格式化——避免每处各写一遍 toFixed */
export function formatMoney(cents, currency = 'USD', locale = 'en-US') {
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
}
export function formatBytes(bytes) {
    if (bytes < 1024)
        return `${bytes} B`;
    const units = ['KB', 'MB', 'GB', 'TB'];
    let value = bytes / 1024;
    let index = 0;
    while (value >= 1024 && index < units.length - 1) {
        value /= 1024;
        index += 1;
    }
    return `${value.toFixed(1)} ${units[index]}`;
}
/** 配额水位颜色，与后端的 quotaLevel 语义保持一致 */
export function quotaTone(used, limit) {
    if (limit <= 0)
        return 'danger';
    const ratio = used / limit;
    if (ratio >= 1)
        return 'danger';
    if (ratio >= 0.8)
        return 'warn';
    return 'success';
}
export const visuallyHidden = {
    position: 'absolute',
    inlineSize: 1,
    blockSize: 1,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    whiteSpace: 'nowrap',
};
//# sourceMappingURL=index.js.map